module.exports = __webpack_public_path__ + "img/SL-M-100-120.9b082bbf.svg";